import React from 'react';
import Table from 'rc-table';
import classnames from 'classnames';
import type { CnMiniTableProps } from './types';

import './index.scss';

/**
 * @category 组件
 * @description mini表格
 */
export const CnMiniTable: React.FC<CnMiniTableProps> = (props: CnMiniTableProps) => {
  const prefixCls = 'cn-mini-table';
  const { className, ...rest } = props;
  const cls = classnames({
    className,
  });
  return (
    <div className={`${prefixCls}-wrap`}>
      <Table className={cls} prefixCls={prefixCls} {...rest} />
    </div>
  );
};

export type { CnMiniTableProps } from './types';

CnMiniTable.defaultProps = {
  /* hasBorder: true, */
};
CnMiniTable.displayName = 'CnMiniTable';
